import client from "../client";
import { store } from "../../store";
import { memberActionTypes } from "lib/store/member/reducer";

export interface GetTransactionHistoryDepositAndWithdrawRequest {
  box: GetTransactionHistoryDepositAndWithdrawResponse[];
  start: number;
  limit: number;
}

export interface GetTransactionHistoryDepositAndWithdrawResponse {
  ID?: number;
  CreatedAt?: Date;
  UpdatedAt?: Date;
  DisplayCreatedAt?: string;
  DisplayUpdatedAt?: string;
  MemberID?: number;
  StaffID?: number | null;
  TransactionTypeID?: number;
  Uncalculated?: boolean;
  GamesID?: number;
  AfterBetAmount?: number;
  Amount?: number;
  CurrencyID?: number;
  IPAddress?: string;
  HashKey?: string;
  CurrentMemberBalance?: number;
  Reject?: boolean;
  MemberCreatedAt?: Date;
  MemberUpdatedAt?: Date;
  DisplayMemberCreatedAt?: string;
  DisplayMemberUpdatedAt?: string;
  BankNumber?: string;
  BankName?: string;
  Context?: string;
  SMPoint?: number;
  Username?: string;
  BankAccount?: string;
  TransactionTypeName?: string;
  GameNameEN?: string;
  GameNameTH?: string;
  GameSymbol?: string;
  CurrencyName?: string;
  CurrencyCountry?: string;
}

export default function API(
  request: GetTransactionHistoryDepositAndWithdrawRequest
): Promise<GetTransactionHistoryDepositAndWithdrawResponse[]> {
  return client
    .get(`members/get_transaction_history_deposit_and_withdraw`, {
      params: { start: request.start, limit: request.limit },
    })
    .then((response) => response.data)
    .then((json: GetTransactionHistoryDepositAndWithdrawResponse[]) => {
      store.dispatch({
        type:
          memberActionTypes.ACTION_USER_UPDATE_TRANSACTION_DEPOSIT_AND_WITHDRAW,
        payload: [...request.box, ...json],
      });
      return json;
    });
}
